// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qCCf","colBig":"styles_colBig__1eMC0","colSmall":"styles_colSmall__3-EY_"};